/**
 * Shared `{data:}` envelope unwrap for `apiV2` Laravel Resource responses.
 * `apiV2` has no global unwrap interceptor — every client must call this
 * explicitly (see /learnings/frontend/2026-07-15-jsonresource-envelope-unwrap-per-apiclient.md).
 * No sibling task should hand-roll its own unwrap.
 */
export const unwrapApiV2 = <T>(responseData: unknown): T => {
	if (
		responseData !== null &&
		typeof responseData === "object" &&
		"data" in responseData
	) {
		return (responseData as { data: T }).data;
	}

	return responseData as T;
};
